export const isMultiChoice = (question) => question && question.type ? question.type.toLowerCase() === "multichoice" : false;

export const isMulti = (question) => question && question.subType ? question.subType.toLowerCase() === "multi" : false;

export const isSingle = (question) => question && question.subType ? question.subType.toLowerCase() === "single" : false;

// otherAnswer needs to be normalized as iOS and android send the response delimiter without space
export const sanitizeOtherComment = (otherAnswer = "") => {
  return otherAnswer.match(/:[^\s]/) ? otherAnswer.replace(":", ": ") : otherAnswer;
};

export const isOtherOptionEnabled = (question) => {
  if (!question) {
    return false;
  }

  const { isDisplayOtherOptionContentField, displayOtherOptionContentField } = question;
  return isDisplayOtherOptionContentField || displayOtherOptionContentField || false;
};

export const isOtherOptionCommentEnabled = (question) => {
  if (!question) {
    return false;
  }

  const { isDisplayOtherCommentSelectedField, displayOtherCommentSelectedField } = question;
  return isDisplayOtherCommentSelectedField || displayOtherCommentSelectedField || false;
};

export const getOtherOptionId = (question) => question && question.otherOptionId ? question.otherOptionId : null;

export const getOtherOptionLabel = (question) => question ? question.otherOptionContentField || null : null;

export const getOtherOptionPlaceholder = (question) => question ? question.otherCommentSelectedField || null : null;

export const getOptions = (question) => question && question.options ? question.options : [];

export const toArray = (target) => {
  if (!target || !target.length) {
    return [];
  }

  const isArray = Array.isArray(target);
  const arrayString = isArray ? target.join(",") : target;

  return arrayString.split(",").map(o => o.trim());
};

export const getOptionIds = (question, isComparing = false) => {
  if (!question) {
    return [];
  }

  return isComparing ? toArray(question.previousOptionsIds) : toArray(question.optionsIds);
};

export const getSelectedOptions = (question, isComparing = false) => {
  if (!question) {
    return [];
  }

  const optionIds = getOptionIds(question, isComparing);
  const options = getOptions(question);

  return options.filter(o => optionIds.includes(o.id));
};

export const getDisplayAnswerText = (question, isComparing = false) => {
  if (!question) {
    return "";
  }

  const { displayAnswerText, display_answer_text, answer, previousAnswer, privius_display_answer_text } = question;
  let target;

  if (isComparing) {
    target = previousAnswer || privius_display_answer_text;
  } else {
    target = displayAnswerText || display_answer_text || answer;
  }

  return target || "";
};

export const isOtherOptionSelected = (question, isComparing = false) => {
  if (!question) {
    return false;
  }

  const otherOptionId = getOtherOptionId(question);
  const optionsIds = getOptionIds(question, isComparing);

  return otherOptionId && optionsIds.includes(otherOptionId);
};

export const getOtherAnswerComment = (question, isComparing = false) => {
  const otherOptionId = getOtherOptionId(question);
  const otherOptionLabel = getOtherOptionLabel(question);
  const otherOptionComment = {
    id: otherOptionId,
    label: otherOptionLabel,
    value: null
  };

  if (!question || !isOtherOptionSelected(question, isComparing)) {
    return otherOptionComment;
  }

  const selectedOptions = getSelectedOptions(question, isComparing);
  let displayAnswerText = getDisplayAnswerText(question, isComparing);

  selectedOptions.forEach(option => {
    const bodyText = option.formattedBody || option.body;

    if (bodyText && displayAnswerText.includes(bodyText)) {
      // Remove the option body and any trailing ', ' if exists
      displayAnswerText = displayAnswerText.replace(new RegExp(`${bodyText},? *`, "g"), "");
    }
  });

  if (!displayAnswerText || !displayAnswerText.length) {
    return otherOptionComment;
  }

  const commentSplit = sanitizeOtherComment(displayAnswerText).split(": ");

  if (commentSplit.length > 1) {
    otherOptionComment.value = commentSplit[1];
  }

  return otherOptionComment;
};
